export default __webpack_public_path__ + "static/media/customServiceExample.7af8b151.png";